/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — product listing page
 *   extends:   Route
 *   template:  none
 *   model:     none (no model hook; product data lives on the application
 *              controller)
 *   key:       setupController
 *   uses:      controllerFor('application') — collapses showCart/showMenu
 *              chrome
 *   siblings:  controllers/list.js
 *   tests:     tests/unit/routes/simple-routes-test.js
 *
 * Product-listing route for the e-commerce storefront.
 */
import Route from '@ember/routing/route';

import { set } from '@ember/object';

export default class ListRoute extends Route {
  setupController(/*controller*/) {
    var application = this.controllerFor('application');
    set(application, 'showCart', null);
    set(application, 'showMenu', null);
    //application.loadDataTask.perform();
  }
}
